module.exports = __webpack_public_path__ + "img/12d.e9ecf1d6.png";